import { render, staticRenderFns } from "./submitSuccess.vue?vue&type=template&id=f05afdaa&scoped=true"
import script from "./submitSuccess.vue?vue&type=script&lang=js"
export * from "./submitSuccess.vue?vue&type=script&lang=js"
import style0 from "./submitSuccess.vue?vue&type=style&index=0&id=f05afdaa&prod&lang=less&scoped=true"
import style1 from "./submitSuccess.vue?vue&type=style&index=1&id=f05afdaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05afdaa",
  null
  
)

export default component.exports